import { render, staticRenderFns } from "./livePage.vue?vue&type=template&id=e015f9fa"
import script from "./livePage.vue?vue&type=script&lang=js"
export * from "./livePage.vue?vue&type=script&lang=js"
import style0 from "./livePage.vue?vue&type=style&index=0&id=e015f9fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports